module.exports = __webpack_public_path__ + "img/visa.58bcac48.jpg";